import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { OfferCard } from './OfferCard';
import { WebinarOffer } from '@/store/webinar/types';
import { X } from 'lucide-react';

interface OfferModalDemoProps {
  isOpen: boolean;
  onClose: () => void;
  data: Partial<WebinarOffer>;
}

export function OfferModalDemo({ isOpen, onClose, data }: OfferModalDemoProps) {
  useLanguage();
  return (
    <>
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent 
          className="max-w-3xl max-h-[90vh] overflow-y-auto"
          aria-describedby="offer-demo-description"
        >
          <DialogHeader>
            <DialogTitle className="sr-only">{translateInterfaceText("Preview da Oferta")}</DialogTitle>
            {data.modal_allow_close && (
              <button
                onClick={onClose}
                className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none"
              >
                <X className="h-4 w-4" />
                <span className="sr-only">{translateInterfaceText("Fechar")}</span>
              </button>
            )}
          </DialogHeader>

          <div id="offer-demo-description" className="space-y-4">
            <p className="text-sm text-muted-foreground text-center mb-4">
              {translateInterfaceText("Preview: Como a oferta aparecerá no webinário")}</p>
            
            <OfferCard variant="desktop" data={data} />

            {data.modal_close_delay_sec > 0 && (
              <p className="text-xs text-muted-foreground text-center">
                {translateInterfaceText("Fechamento bloqueado por")}{" "}{data.modal_close_delay_sec}{translateInterfaceText("s após abertura")}</p>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Sticky Bar Demo */}
      {isOpen && data.modal_sticky_bar && (
        <div className="fixed bottom-0 left-0 right-0 bg-background border-t shadow-xl p-4 z-[100] animate-slide-up">
          <div className="flex items-center justify-between max-w-6xl mx-auto gap-4">
            <div className="flex-1">
              <p className="font-semibold text-foreground">{data.title}</p>
              {data.subtitle && (
                <p className="text-sm text-muted-foreground">{data.subtitle}</p>
              )}
            </div>
            <Button
              size="lg"
              style={{ 
                backgroundColor: data.cta1_color || '#6366f1',
                color: '#ffffff'
              }}
            >
              {data.cta1_label || translateInterfaceText("Quero aproveitar")}
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
